import React, {Component} from 'react';
import _ from 'lodash';
import {Path} from 'path-parser';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

import Context from 'utils/Context';

import './Router.scss';
import {TEMPLATES, ROUTES} from './routes';

class Router extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previousComponent: null,
      currentComponent: null,
      currentRoute: {template: ''},
      current: null,
      previous: null,
      n: 0,
    };
    this.beforeExit = () => true;
    this.go = this.go.bind(this);
    this.removePrevious = this.removePrevious.bind(this);
    this.handleCanExit = this.handleCanExit.bind(this);
    this.routerRef = React.createRef();
    this.scrollYs = {};
  }
  handleCanExit(cb) {
    this.beforeExit = cb;
  }
  componentDidMount() {
    this.context.history.listen((location, action) => {
      if (action !== 'REPLACE') {
        let url = location.pathname.replace(this.base, '');
        this.go(url);
      }
    });
    let url = window.location.pathname.replace(this.base, '');
    this.go(url);
  }
  removePrevious(e) {
    if (e.target.parentNode === this.routerRef.current)
      this.setState({previousComponent: null, previous: null, previousRoute: null});
  }
  go(url) {
    if (this.state.n > 0) {
      this.context.methods.setAppState({
        query: {},
      });
    }
    if (this.beforeExit()) {
      this.beforeExit = () => true;
      let currentRoute,
        currentTemplate,
        currentComponent,
        currentParams,
        modState = {};
      const state = this.state;
      if (url !== this.state.current) {
        this.scrollYs[this.state.current] = window.scrollY;
        currentRoute = _.find(ROUTES, r => {
          let path = new Path(r.url);
          currentParams = path.test(url);
          return currentParams;
        });
        if (!currentRoute) {
          if (ROUTES.length > 0) this.context.history.replace(ROUTES[0].url);
        } else {
          if (currentRoute.template !== this.state.currentRoute.template) {
            currentTemplate = _.find(TEMPLATES, {id: currentRoute.template});
            currentComponent = currentTemplate.component;
            if (this.state.currentComponent) {
              modState.previousComponent = this.state.currentComponent;
              modState.previousRoute = this.state.currentRoute;
              modState.previousParams = this.state.currentParams;
              modState.previous = this.state.current;
            }
            modState.currentComponent = currentComponent;
            modState.sameComponent = false;
          } else {
            modState.sameComponent = true;
          }
          this.setState(
            {
              ...state,
              ...modState,
              currentRoute,
              currentParams,
              current: url,
              n: this.state.n + 1,
            },
            () => {
              setTimeout(() => window.scrollTo(0, this.scrollYs[url] || 0), 1);
            },
          );
        }
      }
    } else {
      this.context.history.replace(this.state.current);
    }
  }
  render() {
    const {goTo, modele, appState, methods, ed} = this.context;
    let Cp = this.state.previousComponent;
    let previous = '';
    if (Cp)
      previous = (
        <Cp
          goTo={goTo}
          data={this.state.previousRoute}
          params={this.state.previousParams}
          modele={modele}
          appState={appState}
          methods={methods}
          ed={ed}
          n={this.state.n}
        />
      );
    let Cc = this.state.currentComponent;
    let current = '';
    if (Cc)
      current = (
        <Cc
          goTo={goTo}
          data={this.state.currentRoute}
          params={this.state.currentParams}
          modele={modele}
          appState={appState}
          methods={methods}
          canExit={this.handleCanExit}
          ed={ed}
          n={this.state.n}
        />
      );
    let pages = [
      {
        url: this.state.previous,
        template: this.state.previousRoute ? this.state.previousRoute.template : null,
        content: previous,
        type: 'previous',
      },
      {
        url: this.state.current,
        template: this.state.currentRoute.template,
        content: current,
        type: 'current',
        sameComponent: this.state.sameComponent,
      },
    ];
    let classes = 'router ' + this.context.appState.screenSize;
    return (
      <div className={classes} ref={this.routerRef}>
        {pages.map(p => {
          let pClass = 'router-route router-' + p.type;
          if (p.sameComponent) pClass = 'router-route router-samecomponent router-' + p.type;
          if (p.url) {
            return (
              <div
                key={p.template}
                className={pClass}
                onTransitionEnd={p.type === 'previous' && this.state.previous ? this.removePrevious : undefined}
                style={p.type === 'previous' ? {top: -this.scrollYs[p.url]} : {}}
              >
                <MuiPickersUtilsProvider utils={MomentUtils}>{p.content}</MuiPickersUtilsProvider>
              </div>
            );
          } else return '';
        })}
      </div>
    );
  }
}

Router.contextType = Context;
export default Router;
